module.exports = __webpack_public_path__ + "img/logo1.f0546469.svg";